module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/typography-71bffbf66030e9c197c42dbef8b2417c.jpg";